import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("tplm_token") || ""}` },
});

export const imgSrc = (url) =>
  !url ? "" : url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}/api/files/${url}`;
